<ng-container *ngIf="data?.length; else allLanguages">
  <p500-ui-many-items [data]="data" title="All Languages" [tmpl]="tmpl" [previewTmpl]="previewTmpl"> </p500-ui-many-items>
</ng-container>

<ng-template let-data="data" #previewTmpl>
  <gtd-ui-field-default-language [data]="data"> </gtd-ui-field-default-language>
</ng-template>

<ng-template let-data="data" #tmpl>
  <span class="font-headline-5">
    <gtd-ui-field-default-language [data]="data"> </gtd-ui-field-default-language>
  </span>
</ng-template>

<ng-template #allLanguages>
  <img src="/assets/new-img/flags/all.svg" width="32" height="16" class="mr-8" />
  <span class="text-color text-color--gray" i18n="@@common.all_languages">All Languages</span>
</ng-template>
